import React, { memo, useMemo } from 'react';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import { rem } from './values';
export const toolTipWebContentWidth = rem(268);
const ToolTipContentWeb = ({ title, subtitle }) => {
    const subTitleNode = useMemo(() => {
        if (Array.isArray(subtitle)) {
            return (<>
          {subtitle.map((paragraph, index) => (<React.Fragment key={index}>
              {index > 0 && <Spacer h={10}/>}
              <Text TextThin-14 Gray>
                {paragraph}
              </Text>
            </React.Fragment>))}
        </>);
        }
        if (React.isValidElement(subtitle))
            return subtitle;
        if (typeof subtitle === 'string') {
            return (<Text TextThin-14 Gray>
          {typeof subtitle === 'string' ? `${subtitle} ` : ''}
        </Text>);
        }
        return null;
    }, [subtitle]);
    return (<>
      <Text Text-16>{title}</Text>
      <Spacer h={8}/>
      {subTitleNode}
    </>);
};
export default memo(ToolTipContentWeb);
